import { useMantineTheme } from "@mantine/core";
import Lottie from "react-lottie";

import Flex from "components/Flex";
import Text from "components/Text";

import animation from "./lottie/tractable-animation.json";
import { hex2rgba } from "./utils/hexToRgbaConverter";

interface LoaderProps {
  message?: string;
}

export const Loader = ({ message }: LoaderProps) => {
  const theme = useMantineTheme();

  const animationDefaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
  };

  return (
    <Flex align="center" mt={48}>
      <style
        dangerouslySetInnerHTML={{
          __html: `
      .custom-stroke-color {
        stroke: ${hex2rgba(theme.other.primary[60])};
      }
    `,
        }}
      />
      <Lottie options={animationDefaultOptions} isClickToPauseDisabled={true} height={145} width={145} />
      {message && (
        <Text mt={32} mb={64}>
          {message}
        </Text>
      )}
    </Flex>
  );
};
